var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackageBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5128 26.9579V63.3431C70.5128 67.0265 67.5268 70.0125 63.8434 70.0125H17.1572C13.4738 70.0125 10.4878 67.0265 10.4878 63.3431V26.9579C10.4865 26.0536 10.6692 25.1584 11.0247 24.3268L15.4265 14.0259C16.479 11.5743 18.8912 9.9859 21.5591 9.98751H59.4415C62.1118 9.98751 64.5247 11.5804 65.5741 14.0359L69.9759 24.3268C70.3309 25.1585 70.5135 26.0536 70.5128 26.9579Z",
    stroke: "#00B26B",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4878 26.6611H70.4794",
    stroke: "#00B26B",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1695 9.98751L50.5042 26.6611V37.4156C50.4216 38.9192 49.1403 40.0738 47.6363 40H33.3637C31.8597 40.0738 30.5784 38.9192 30.4958 37.4156V26.6611L33.8306 9.98751",
    stroke: "#00B26B",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4919 60.0083H27.1614",
    stroke: "#00B26B",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageBox);
export default __webpack_public_path__ + "static/media/packageBox.94f2b785b0118da0aa82a9fa9399d166.svg";
export { ForwardRef as ReactComponent };